// extracted by mini-css-extract-plugin
export default {"filterIcon":"Integration_filterIcon__w8IQB","add-icon":"Integration_add-icon__RHAA+","icon-24":"Integration_icon-24__grLQ-"};